<template>
  <div class="main-wrapper events-page innerpagebg">
    <layouts-header></layouts-header>
    <breadcrumb :title="title" :text="text" :text1="text1" />
    <div class="content">
      <div class="container">
        <section class="services">
          <div class="row">
            <div
              class="col-12 col-sm-12 col-md-6 col-lg-4"
              v-for="record in Events"
              :key="record.id"
            >
              <div class="listing-item">
                <div class="listing-img">
                  <router-link to="event-details">
                    <img
                      :src="require(`@/assets/img/events/${record.Event}`)"
                      class="img-fluid"
                      alt="Event"
                    />
                  </router-link>
                  <div class="date-info text-center">
                    <h2>{{ record.Date }}</h2>
                    <h6>Sep, 2023</h6>
                  </div>
                </div>
                <div class="listing-content">
                  <ul class="d-flex justify-content-start align-items-center">
                    <li><i class="feather-clock"></i>06:20 AM</li>
                    <li><i class="feather-map-pin"></i>152, 1st Street New York</li>
                  </ul>
                  <h4 class="listing-title">
                    <router-link to="event-details">{{ record.Name }}</router-link>
                  </h4>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
    </div>
  </div>
  <layout-footer></layout-footer>
</template>
<script>
import Events from "@/assets/json/events.json";
export default {
  data() {
    return {
      Events: Events,
      title: "Events",
      text: "Home",
      text1: "Events",
    };
  },
};
</script>
